// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/shared_policy_outcomes.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * The SkippedAction object describes the outcome of a policy step that has been skipped.
 *
 * @generated from protobuf message c1.api.policy.v1.SkippedAction
 */
export interface SkippedAction {
    /**
     * The UserID of the user who skipped this step.
     *
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * The ID of the policy step that was created as a result of this skipping.
     *
     * @generated from protobuf field: string new_policy_step_id = 2;
     */
    newPolicyStepId: string;
    /**
     * The datetime, in RFC3339 format, of when the step was skipped.
     *
     * @generated from protobuf field: google.protobuf.Timestamp skipped_at = 3;
     */
    skippedAt?: Timestamp;
}
/**
 * The restart action describes the outcome of policy steps for when the task was restarted. This can be applied to multiple steps since restart skips all pending next steps.
 *
 * @generated from protobuf message c1.api.policy.v1.RestartAction
 */
export interface RestartAction {
    /**
     * The user that submitted the restart action.
     *
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * The step ID that was restarted. Potentially multiple "history" steps will reference this ID to indicate by what step they were restarted.
     *
     * @generated from protobuf field: string old_policy_step_id = 2;
     */
    oldPolicyStepId: string;
    /**
     * The datetime, in RFC3339 format, of when the step was restarted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp restarted_at = 3;
     */
    restartedAt?: Timestamp;
}
/**
 * The ReassignedAction object describes the outcome of a policy step that has been reassigned.
 *
 * @generated from protobuf message c1.api.policy.v1.ReassignedAction
 */
export interface ReassignedAction {
    /**
     * The UserID of the person who reassigned this step.
     *
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * The ID of the policy step that was created as a result of this reassignment.
     *
     * @generated from protobuf field: string new_policy_step_id = 2;
     */
    newPolicyStepId: string;
    /**
     * The datetime, in RFC3339 format, of when the step was reassigned.
     *
     * @generated from protobuf field: google.protobuf.Timestamp reassigned_at = 3;
     */
    reassignedAt?: Timestamp;
}
// @generated message type with reflection information, may provide speed optimized methods
class SkippedAction$Type extends MessageType<SkippedAction> {
    constructor() {
        super("c1.api.policy.v1.SkippedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "skipped_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.SkippedAction
 */
export const SkippedAction = new SkippedAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestartAction$Type extends MessageType<RestartAction> {
    constructor() {
        super("c1.api.policy.v1.RestartAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "restarted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.RestartAction
 */
export const RestartAction = new RestartAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReassignedAction$Type extends MessageType<ReassignedAction> {
    constructor() {
        super("c1.api.policy.v1.ReassignedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "reassigned_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ReassignedAction
 */
export const ReassignedAction = new ReassignedAction$Type();
